import { useState } from 'react'
import Header from '../Header/Header.js'
import Footer from '../Footer/Footer.js'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { FaSyncAlt } from "react-icons/fa";
import Select from 'react-select';
import useScrollToTop from '../components/useScrollToTop.js';
import { IoLocationSharp } from "react-icons/io5";
import SpinLoader from '../components/SpinLoader.js';
import { FaCalculator, FaPlaneDeparture } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import { useLazyQuery, useQuery } from '@apollo/client';
import { CALCULATE_RATE, GET_AVAILABLE_COUNTRIES } from '../graphql/Query/Advertise.js';
import { useApolloClient } from '@apollo/client';
import WeightOptionsLoader from './WeightOptionsLoader.js';
import * as Yup from 'yup';
import ForeignRateCalcy from './ForeignRateCalcy.js';


const ForeignAir = () => {

    const client = useApolloClient();
    useScrollToTop();
    const [showModal, setShowModal] = useState(false);
    const [rateData, setRateData] = useState(null);
    const [showDestinationPincode, setshowDestinationPincode] = useState();
    const [calculateRate] = useLazyQuery(CALCULATE_RATE);
    const [weightOptions, setWeightOptions] = useState([]);
    const itemtype = [
        { value: "Document", label: "Document" },
        { value: "Non Document", label: "Non Document" },

    ];

    const india = [
        { value: "India (Bharat)", label: "India (Bharat)" },
    ];
    const { data, refetch } = useQuery(GET_AVAILABLE_COUNTRIES, {
        variables: {
            itemType: null, // initial empty
        },
        fetchPolicy: "cache-and-network",
    });

    const countryOptions = data?.getAvailableCountries || [];


    const validationSchema = Yup.object().shape({
        itemType: Yup.string().required('Item Type is required'),
        allCountry: Yup.string().required('Ship To is required'),
        weight: Yup.string().required('Weight is required'),
        shipFrom: Yup.string().required('Ship From is required'),
        // deliveryPincode: Yup.string().when('$needsPincode', {
        //     is: true,
        //     then: Yup.string().required('Destination Pincode is required'),
        //     otherwise: Yup.string().notRequired(),
        // }),
    });


    // const showDestinationPincode = data?.getAvailableCountries
    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const { allCountry, weight, itemType, pickUpPincode, deliveryPincode } = values;

            const { data } = await calculateRate({
                variables: {
                    country: allCountry,
                    state: "", // if applicable
                    originPincode: pickUpPincode || "",
                    destinationPincode: deliveryPincode || "",
                    weight: parseFloat(weight),         // Ensure it's a number
                    itemType: itemType,
                },
            });

            // console.log('Calculated Rate:', data);
            setRateData({
                country: allCountry,
                destinationPincode: deliveryPincode,
                itemType,
                weight,
                rate: data?.calculateRate,
            });
            setShowModal(true);
            // alert(`Rate: ₹${data?.calculateRate}`);
        } catch (error) {
            console.error('Error calculating rate:', error);
            // alert("Failed to calculate rate");
        } finally {
            setSubmitting(false);
        }
    };

    const [expandedIndex, setExpandedIndex] = useState(null);
    // console.log('✌️expandedIndex --->', expandedIndex);

    const toggleAccordion = (index) => {
        // Toggle the accordion; close if already open
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    return (
        <div>
            <Header />


            <div className="relative isolate overflow-hidden bg-slate-900 py-16 sm:pt-14">
                <img
                    src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/tailwindimg.avif"
                    alt=""
                    className="absolute inset-0 -z-10 h-full w-full object-cover object-right md:object-center"
                />
                <div
                    className="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl"
                    aria-hidden="true"
                >
                    <div
                        className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                    />
                </div>
                <div
                    className="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:top-[-28rem] sm:ml-16 sm:translate-x-0 sm:transform-gpu"
                    aria-hidden="true"
                >
                    <div
                        className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                    />
                </div>
                <div className="mx-auto  max-w-auto md:px-8 lg:px-8">
                    <div className='flex flex-col lg:flex-row lg:space-x-3 gap-y-10'>
                        <div className="lg:w-2/3 md:rounded-l-lg rounded-none md:py-8 md:px-9 p-6 bg-white ring-1 ring-slate-900/5 shadow-md">


                            <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-4 space-y-3 sm:space-y-0">
                                {/* Left Section - Icon & Title */}
                                <div className="flex items-center">
                                    <FaPlaneDeparture className="text-2xl me-3 text-gray-800 drop-shadow-lg ms-2" />
                                    <h1 className="text-lg sm:text-xl font-bold">
                                        International Rates Calculator
                                    </h1>
                                </div>

                                {/* Right Section - Refresh Button */}
                                <button
                                    onClick={() => window.location.reload()}
                                    className="flex items-center justify-center gap-2 text-xs sm:text-sm px-4 py-1 bg-slate-700 text-white rounded-lg hover:bg-slate-800 w-full sm:w-auto"
                                >
                                    <FaSyncAlt /> Refresh
                                </button>
                            </div>


                            <p className="mb-5 text-sm">At AlgarXpress, we make Global shipping easy and transparent. Our free rate calculator is designed to help you quickly and accurately estimate Shipment charges based on everything that matters—weight, destination, and more.</p>

                            <div className="bg-white rounded-lg">
                                {/* Tabs */}
                                <div className="flex gap-2 border-b">
                                    {/* Active Button */}


                                    {/* Inactive Button */}
                                    <Link to='/calculatorcourier'>  <button className="px-4 py-2 text-sm text-gray-600 hover:text-black">

                                        India's Shipment
                                    </button></Link>
                                    <Link to='/foreignair'>  <button className="px-4 py-2 text-sm font-semibold text-black bg-blue-100 rounded-t-md border-b-2 border-black">
                                        Global Shipment
                                    </button></Link>
                                </div>

                            </div>
                            <Formik
                                initialValues={{
                                    pickUpPincode: '',
                                    deliveryPincode: '',
                                    weight: '',
                                    itemType: '',
                                    allCountry: '',
                                    needsPincode: false,
                                    shipFrom: "India (Bharat)",
                                }}
                                validationSchema={validationSchema}
                                validateOnChange={true}
                                validateOnBlur={true}
                                enableReinitialize
                                validationContext={{ needsPincode: showDestinationPincode?.needsPincode }}
                                onSubmit={handleSubmit}

                            >
                                {({ isSubmitting, resetForm, setFieldValue, values }) => {
                                    return (
                                        <>
                                            <WeightOptionsLoader client={client} setWeightOptions={setWeightOptions} values={values} />
                                            <Form>
                                                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 mt-7 gap-6'>

                                                    <div className="relative z-40">
                                                        <label>Ship From <span className="text-red-500">*</span></label>
                                                        <div className="mt-2 z-50">
                                                            <Field name="shipFrom">
                                                                {({ field, form }) => {
                                                                    const selectedOptionindia = india.find(option => option?.value === field?.value);
                                                                    return (
                                                                        <Select
                                                                            value={field.value === "" ? null : selectedOptionindia}
                                                                            options={india}
                                                                            className="w-full focus:outline-none z-50"
                                                                            styles={{
                                                                                control: (base, state) => ({
                                                                                    ...base,
                                                                                    borderColor: state.isFocused ? '#2b2b2b' : '#2b2b2b',
                                                                                    '&:hover': { borderColor: '#2b2b2b' },
                                                                                    boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                                                    zIndex: 1050,
                                                                                }),
                                                                                singleValue: (base) => ({
                                                                                    ...base,
                                                                                    color: '#000000',
                                                                                    zIndex: 1050,
                                                                                }),
                                                                                option: (base, state) => ({
                                                                                    ...base,
                                                                                    backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                                                                    color: state.isSelected ? 'white' : '#000000',
                                                                                    '&:hover': {
                                                                                        backgroundColor: '#f0f0f0',
                                                                                        color: '#000000',
                                                                                    },
                                                                                    zIndex: 1050,
                                                                                }),
                                                                                menu: (base) => ({
                                                                                    ...base,
                                                                                    zIndex: 1050,
                                                                                    position: 'absolute',
                                                                                }),
                                                                            }}
                                                                            isSearchable={false}
                                                                            placeholder="Select India"
                                                                            onChange={option => form.setFieldValue(field.name, option.value)}
                                                                            onBlur={() => form.setFieldTouched(field.name, true)}
                                                                        />
                                                                    );
                                                                }}
                                                            </Field>
                                                            <ErrorMessage name="shipFrom" component="div" className="text-red-600 text-sm mt-1 z-50" />
                                                        </div>
                                                    </div>

                                                    <div className="relative z-50">
                                                        <label>Item Type <span className="text-red-500">*</span></label>
                                                        <div className="mt-2 z-50">
                                                            <Field name="itemType">
                                                                {({ field, form }) => {
                                                                    const itemtypeoption = itemtype?.find(option => option?.value === field?.value);
                                                                    return (
                                                                        <Select
                                                                            value={field.value === "" ? null : itemtypeoption}
                                                                            // options={weightOptions}
                                                                            options={itemtype.map(option => ({
                                                                                ...option,
                                                                                // isDisabled: true, // Disable all options
                                                                            }))}
                                                                            className="w-full focus:outline-none z-50"
                                                                            styles={{
                                                                                control: (base, state) => ({
                                                                                    ...base,
                                                                                    borderColor: state.isFocused ? '#2b2b2b' : '#2b2b2b',
                                                                                    '&:hover': { borderColor: '#2b2b2b' },
                                                                                    boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                                                    zIndex: 1050,
                                                                                }),
                                                                                singleValue: (base) => ({
                                                                                    ...base,
                                                                                    color: '#000000',
                                                                                    zIndex: 1050,
                                                                                }),
                                                                                option: (base, state) => ({
                                                                                    ...base,
                                                                                    backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                                                                    color: state.isSelected ? 'white' : '#000000',
                                                                                    '&:hover': {
                                                                                        backgroundColor: '#f0f0f0',
                                                                                        color: '#000000',
                                                                                    },
                                                                                    zIndex: 1050,
                                                                                }),
                                                                                menu: (base) => ({
                                                                                    ...base,
                                                                                    zIndex: 1050,
                                                                                    position: 'absolute',
                                                                                }),
                                                                            }}
                                                                            isSearchable={false}
                                                                            placeholder="Select Item Type"
                                                                            onChange={(selectedOption) => {
                                                                                form.setFieldValue('itemType', selectedOption?.value);

                                                                                // Clear dependent fields:
                                                                                form.setFieldValue('allCountry', '');
                                                                                form.setFieldValue('weight', '');
                                                                                form.setFieldValue('deliveryPincode', '');
                                                                                setshowDestinationPincode(null);
                                                                                form.setFieldValue('needsPincode', false); // also reset needsPincode

                                                                                // Trigger refetch manually:
                                                                                refetch({
                                                                                    itemType: selectedOption?.value || null
                                                                                });
                                                                            }}
                                                                            onBlur={() => form.setFieldTouched(field.name, true)}
                                                                        />
                                                                    );
                                                                }}
                                                            </Field>
                                                            <ErrorMessage name="itemType" component="div" className="text-red-600 text-sm mt-1 z-50" />
                                                        </div>
                                                    </div>

                                                    <div className="relative z-30">
                                                        <label>
                                                            Ship To <span className="text-red-500">*</span>
                                                        </label>
                                                        <div className="mt-2 z-50">
                                                            <Field name="allCountry">
                                                                {({ field, form }) => {
                                                                    const selectedOption = countryOptions.find(option => option.value === field.value);
                                                                    // setshowDestinationPincode(selectedOption);
                                                                    return (
                                                                        <Select
                                                                            value={field.value === "" ? null : selectedOption}
                                                                            options={countryOptions}
                                                                            onChange={(selectedOption) => {
                                                                                form.setFieldValue('allCountry', selectedOption.value);

                                                                                const country = countryOptions.find(option => option.value === selectedOption.value);
                                                                                setshowDestinationPincode(country);
                                                                                const needsPincode = !!country?.needsPincode;


                                                                                form.setFieldValue('needsPincode', needsPincode);


                                                                                // // Optionally clear deliveryPincode if not needed:
                                                                                if (!needsPincode) {
                                                                                    setshowDestinationPincode(null);
                                                                                }
                                                                                form.setFieldValue('deliveryPincode', '');
                                                                                form.setFieldValue('weight', '');
                                                                            }}

                                                                            // onChange={option => form.setFieldValue("allCountry", option.value)}
                                                                            className="w-full focus:outline-none z-50"
                                                                            styles={{
                                                                                control: (base, state) => ({
                                                                                    ...base,
                                                                                    borderColor: state.isFocused ? '#2b2b2b' : '#2b2b2b',
                                                                                    '&:hover': { borderColor: '#2b2b2b' },
                                                                                    boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                                                    zIndex: 1050,
                                                                                }),
                                                                                singleValue: (base) => ({
                                                                                    ...base,
                                                                                    color: '#000000',
                                                                                    zIndex: 1050,
                                                                                }),
                                                                                option: (base, state) => ({
                                                                                    ...base,
                                                                                    backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                                                                    color: state.isSelected ? 'white' : '#000000',
                                                                                    '&:hover': {
                                                                                        backgroundColor: '#f0f0f0',
                                                                                        color: '#000000',
                                                                                    },
                                                                                    zIndex: 1050,
                                                                                }),
                                                                                menu: (base) => ({
                                                                                    ...base,
                                                                                    zIndex: 1050,
                                                                                    position: 'absolute',
                                                                                }),
                                                                            }}
                                                                            isSearchable={true}
                                                                            placeholder="Search Country"
                                                                            onBlur={() => form.setFieldTouched(field.name, true)}
                                                                        />
                                                                    );
                                                                }}
                                                            </Field>
                                                            <ErrorMessage name="allCountry" component="div" className="text-red-600 text-sm mt-1 z-50" />
                                                        </div>
                                                    </div>
                                                    {showDestinationPincode?.needsPincode && (
                                                        <div>
                                                            <label>
                                                                Destination Pincode<span className="text-red-500">*</span>
                                                            </label>
                                                            <div className="mt-2">
                                                                <div className="flex items-center border border-slate-700 p-1.5 rounded-md">
                                                                    <IoLocationSharp className="text-gray-500 mr-2" />
                                                                    <Field
                                                                        type="text"
                                                                        name="deliveryPincode"
                                                                        className="w-full focus:outline-none"
                                                                        placeholder="Delivery"
                                                                    />
                                                                </div>
                                                                <ErrorMessage
                                                                    name="deliveryPincode"
                                                                    component="div"
                                                                    className="text-red-600 text-sm mt-1"
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="relative z-20">
                                                        <label>Weight (Kg) <span className="text-red-500">*</span></label>
                                                        <div className="mt-2 z-50">
                                                            <Field name="weight">
                                                                {({ field, form }) => {
                                                                    const selectedOption = weightOptions.find(option => option.value === field.value);
                                                                    return (
                                                                        <Select
                                                                            value={field.value === "" ? null : selectedOption}
                                                                            // options={weightOptions}
                                                                            options={weightOptions}
                                                                            className="w-full focus:outline-none z-50"
                                                                            styles={{
                                                                                control: (base, state) => ({
                                                                                    ...base,
                                                                                    borderColor: state.isFocused ? '#2b2b2b' : '#2b2b2b',
                                                                                    '&:hover': { borderColor: '#2b2b2b' },
                                                                                    boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                                                    zIndex: 1050,
                                                                                }),
                                                                                singleValue: (base) => ({
                                                                                    ...base,
                                                                                    color: '#000000',
                                                                                    zIndex: 1050,
                                                                                }),
                                                                                option: (base, state) => ({
                                                                                    ...base,
                                                                                    backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                                                                    color: state.isSelected ? 'white' : '#000000',
                                                                                    '&:hover': {
                                                                                        backgroundColor: '#f0f0f0',
                                                                                        color: '#000000',
                                                                                    },
                                                                                    zIndex: 1050,
                                                                                }),
                                                                                menu: (base) => ({
                                                                                    ...base,
                                                                                    zIndex: 1050,
                                                                                    position: 'absolute',
                                                                                }),
                                                                            }}
                                                                            isSearchable={false}
                                                                            placeholder="Select weight"
                                                                            onChange={option => form.setFieldValue(field.name, option.value)}
                                                                            onBlur={() => form.setFieldTouched(field.name, true)}
                                                                        />
                                                                    );
                                                                }}
                                                            </Field>
                                                            <ErrorMessage name="weight" component="div" className="text-red-600 text-sm mt-1 z-50" />
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="flex space-x-3 md:space-x-6 justify-end mt-4 md:mt-8">
                                                    <button
                                                        type="button"
                                                        className="cursor-pointer bg-slate-300 text-black px-10 py-1 rounded-md font-semibold text-sm hover:bg-slate-400 transition"


                                                        onClick={() => {
                                                            resetForm();
                                                            setFieldValue("deliveryPincode", "");
                                                            setFieldValue("weight", "");
                                                            setFieldValue("itemType", "");
                                                            setFieldValue("allCountry", "");
                                                            setFieldValue("shipFrom", "")
                                                            setshowDestinationPincode(null); // If you want to hide pincode field also
                                                        }}>
                                                        Reset
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        disabled={isSubmitting}

                                                        className="py-2.5 px-3 w-full inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-slate-800 text-white hover:bg-slate-900 focus:outline-none text-sm"
                                                    >
                                                        {isSubmitting ? (
                                                            <div className="flex items-center">
                                                                <span className="mr-2">Loading...</span>
                                                                <SpinLoader /> {/* Replace this with your actual loader component */}
                                                            </div>
                                                        ) : (
                                                            <>
                                                                <FaCalculator className="text-white me-2 text-lg" />
                                                                Calculate

                                                            </>
                                                        )}
                                                    </button>
                                                </div>
                                            </Form >
                                        </>
                                    );
                                }}
                            </Formik>
                            {/* {imageurlcalcy ? <img src={cbox} className='mt-11 rounded-lg inset-0 isolate hover:opacity-80 overflow-hidden bg-slate-900 h-60 -z-10 w-full object-cover object-right md:object-center' style={{ height: window.innerWidth >= 2500 ? '40vh' : '15rem' }} alt="" /> : <img src={dbox} className='mt-11 hover:opacity-80 rounded-lg inset-0 isolate overflow-hidden bg-slate-900 h-60 -z-10 w-full object-cover object-right md:object-center' style={{ height: window.innerWidth >= 2500 ? '40vh' : '15rem' }} alt="" />} */}
                            <p className='mt-6 text-sm'>In the rapidly globalizing world, logistics and Shipment services have become more essential than ever before. As businesses, individuals, and organizations look to expand their reach across borders, finding a reliable Shipment service to deliver goods and packages efficiently and securely is critical. One such service provider that stands out in the field of Global Shipment services is AlgarXpress. Renowned for its commitment to excellence, AlgarXpress offers a wide range of shipping solutions to cater to the diverse needs of its clients, both domestic and Global. With a focus on reliability, cost-effectiveness, and customer satisfaction, AlgarXpress is undoubtedly one of the leading names in the Global Shipment industry.</p>
                            <p className='mt-4 text-sm'>AlgarXpress offers fast, secure, and fully digital international courier services from India to 200+ global destinations, designed for e-commerce sellers, small businesses, enterprise clients, and individuals. With convenient home and office pickups, real-time tracking, digital dashboards, automated invoicing, and customs clearance support, we make cross-border shipping smooth and transparent. Whether you're sending a parcel to the USA, documents to Europe, or products to global customers, our smart logistics platform ensures reliable delivery, live updates, and professional service tailored to your business needs.</p>
                        </div>
                        <div className="w-full lg:w-1/3 bg-white p-6 md:rounded-r-lg shadow-md mt-6 lg:mt-0 relative">
                            <img src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/freepik__a-highly-realistic-professional-photo-of-a-large-c__30436.png" alt="" className="rounded-lg hover:opacity-80" />
                            <div className="absolute bottom-7 left-0 w-full font-semibold bg-white bg-opacity-50 text-sm text-black text-center py-2">
                                Global Shipment Services
                            </div>
                        </div>

                    </div>
                </div>


            </div>


            {/* 
            <div className="mx-auto max-w-auto md:p-6 lg:px-8">
                <h1 className='font-bold text-xl mb-7'>{europeSelf.mainTitle}</h1>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {europeSelf.destinations.map((item, index) => (
                        <div
                            key={index}
                            className={`bg-white rounded-lg overflow-hidden`}
                        >
                            <div
                                className="relative cursor-pointer"
                                onClick={() => toggleAccordion(index)} 
                            >
                                <img
                                    src={item.image}
                                    alt={item.destination}
                                    className="w-full h-48 object-cover"
                                />

                                <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-end text-white p-4">
                                    <h3 className="text-sm">To</h3>
                                    <p className="font-bold">{item.destination}</p>
                                    <div className="my-4">
                                        <h3 className="text-sm">Starting From / 21Kg</h3>
                                        <p className="font-bold">{item.price}</p>
                                    </div>
                                    <p className="text-sm">Estimated Delivery Time</p>
                                    <p className="font-bold">{item.deliveryTime}</p>
                                </div>
                            </div>

                        </div>
                    ))}
                </div>
            </div>
           
            {expandedIndex !== null && (
                <div className="mx-auto max-w-auto md:px-6 lg:px-8">
                    <div
                        className="p-6 rounded-lg"
                        style={{
                            backgroundColor: "#E2E5F1",
                        }}
                    >
                        {europeSelf.destinations.map((detail, index) => {
                            if (expandedIndex === index) {
                                return (
                                    <>
                                        <h3 className="text-sm">To</h3>
                                        <p className="font-bold">{detail.destination}</p>
                                        <div key={detail.details.id} className="mb-4 mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
                                            <div className="relative h-48 cursor-pointer rounded-lg overflow-hidden">
                                                <img
                                                    src={detail.image}
                                                    alt={detail.destination}
                                                    className="h-48 w-full object-cover rounded-lg"
                                                />
                                                <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-end text-white p-4 rounded-lg">
                                                    <h3 className="text-sm">To</h3>
                                                    <p className="font-bold">{detail.destination}</p>
                                                    <div className="my-4">
                                                        <h3 className="text-sm">Starting From / 21Kg</h3>
                                                        <p className="font-bold">{detail.price}</p>
                                                    </div>
                                                    <p className="text-sm">Estimated Delivery Time</p>
                                                    <p className="font-bold">{detail.deliveryTime}</p>
                                                </div>
                                            </div>

                                            <div className="flex flex-col justify-start space-y-2">
                                                <h5 className="text-lg mb-2 font-semibold">
                                                    Shipping Price List
                                                </h5>

                                                <div className="flex space-x-10">
                                                    <div className="rounded-lg space-y-2.5" style={{ backgroundColor: "#E2E5F1" }}>
                                                        {detail.details.priceDetails.slice(0, 5).map((priceItem, idx) => (
                                                            <p className="text-sm" key={idx}>
                                                                <span className="text-gray-500 font-semibold me-2">
                                                                    {priceItem.weight || priceItem.weightRange}
                                                                </span>
                                                                /
                                                                <span className="font-semibold ms-2">{priceItem.price}</span>
                                                            </p>
                                                        ))}
                                                    </div>

                                                    <div className="rounded-lg space-y-2.5" style={{ backgroundColor: "#E2E5F1" }}>
                                                        {detail.details.priceDetails.slice(5).map((priceItem, idx) => (
                                                            <p className="text-sm" key={idx}>
                                                                <span className="text-gray-500 font-semibold me-2">
                                                                    {priceItem.weight || priceItem.weightRange}
                                                                </span>
                                                                /
                                                                <span className="font-semibold ms-2">{priceItem.price}</span>
                                                            </p>
                                                        ))}
                                                    </div>
                                                </div>

                                            </div>

                                            <div className="flex flex-col justify-start space-y-7">
                                                <div>
                                                    <h5 className="text-md mb-2 font-semibold">
                                                        Duties & Taxes
                                                    </h5>
                                                    <div className="flex space-x-10">
                                                        <div className="rounded-lg space-y-2.5" style={{
                                                            backgroundColor: "#E2E5F1",
                                                        }}>
                                                            <p className="text-sm text-gray-500 font-semibold">{detail.details.dutiesTaxes} </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div>
                                                    <h5 className="text-md mb-2 font-semibold">
                                                        Estimated Delivery Time(Working days)
                                                    </h5>
                                                    <div className="flex space-x-10">
                                                        <div className="rounded-lg space-y-2.5" style={{
                                                            backgroundColor: "#E2E5F1",
                                                        }}>
                                                            <p className="text-sm text-gray-500 font-semibold">{detail.details.estimatedDeliveryTime}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div>
                                                    <h5 className="text-md mb-2 font-semibold">
                                                        Weight Limit
                                                    </h5>
                                                    <div className="flex space-x-10">
                                                        <div className="rounded-lg space-y-2.5" style={{
                                                            backgroundColor: "#E2E5F1",
                                                        }}>
                                                            <p className="text-sm text-gray-500 font-semibold">{detail.details.weightLimit}</p>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>


                                        </div>

                                        <div className="space-y-7">
                                            <div>
                                                <h5 className="text-md mb-2 font-semibold">
                                                    50% OFF on Global Shipment to Any Country
                                                </h5>
                                                <div className="flex space-x-10">
                                                    <div className="rounded-lg space-y-2.5" style={{
                                                        backgroundColor: "#E2E5F1",
                                                    }}>
                                                        <p className="text-sm text-gray-500 font-semibold">{detail.details.discounts}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <h5 className="text-md mb-2 font-semibold">
                                                    Pickup and Packaging
                                                </h5>
                                                <div className="flex space-x-10">
                                                    <div className="rounded-lg space-y-2.5" style={{
                                                        backgroundColor: "#E2E5F1",
                                                    }}>
                                                        <p className="text-sm text-gray-500 font-semibold">{detail.details.pickupPackaging}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <h5 className="text-md mb-2 font-semibold">
                                                    Multiple Boxes
                                                </h5>
                                                <div className="flex space-x-10">
                                                    <div className="rounded-lg space-y-2.5" style={{
                                                        backgroundColor: "#E2E5F1",
                                                    }}>
                                                        <p className="text-sm text-gray-500 font-semibold">{detail.details.multipleBoxes}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <h5 className="text-md mb-2 font-semibold">
                                                    Restricted Items
                                                </h5>
                                                <div className="flex space-x-10">
                                                    <div className="rounded-lg space-y-2.5" style={{
                                                        backgroundColor: "#E2E5F1",
                                                    }}>
                                                        <p className="text-sm text-gray-500 font-semibold">{detail.details.restrictedItems}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <h5 className="text-md mb-2 font-semibold">
                                                    Delivery Attempts
                                                </h5>
                                                <div className="flex space-x-10">
                                                    <div className="rounded-lg space-y-2.5" style={{
                                                        backgroundColor: "#E2E5F1",
                                                    }}>
                                                        <p className="text-sm text-gray-500 font-semibold">{detail.details.deliveryAttempts}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div className='flex mt-7 justify-between'>
                                            <div>
                                                <h5 className="text-md mb-2 font-semibold">
                                                    Suitable For
                                                </h5>
                                                <div className="flex space-x-10">
                                                    <div className="rounded-lg space-y-2.5" style={{
                                                        backgroundColor: "#E2E5F1",
                                                    }}>
                                                        <p className="text-sm text-gray-500 font-semibold">{detail.details.suitableFor}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div>
                                                <p className='text-sm text-center mb-2'>Proceed with Shipping</p>
                                                <button
                                                    className=" bg-slate-800 text-white font-semibold px-12 py-2 hover:bg-slate-900 rounded-lg"
                                                >
                                                    Ship Now
                                                </button>
                                            </div>

                                        </div>
                                    </>
                                );
                            }
                            return null;
                        })}
                    </div>
                </div>
            )} */}
            {showModal && (
                <ForeignRateCalcy
                    rateData={rateData}
                    onClose={() => setShowModal(false)}
                />
            )}


            <Footer />
        </div >
    )
}

export default ForeignAir
